module.exports = __webpack_public_path__ + "img/20201103_140005.cd3bffb2.jpg";